module.exports = __webpack_public_path__ + "static/disney-f4755a62f5b12e602d54ac3cbba602c6.png";